import { Header } from "../../../../UI";

const FormHeader = ({ className }) => {
    return (
        <Header className={className}>
            <h2> Login </h2>
        </Header>
    );
};

export default FormHeader;
